module.exports = __webpack_public_path__ + "static/media/playLogo.ea1dc72e.svg";